import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "@client/store";
import { StatisticDesktopSkeletonPage } from "@common/components/Statistic/StatisticDesktopSkeletonPage";
import { useIsMobile } from "@common/hooks/isMobile";
import { StatisticTouchSkeletonPage } from "@common/components/Statistic/StatisticTouchSkeletonPage";
import { CreateCampaignTabStatisticTouch } from "@client/pages/CreateCampaign/Tabs/CreateCampaignTabStatisticTouch";
import { CreateCampaignTabStatisticDesktop } from "@client/pages/CreateCampaign/Tabs/CreateCampaignTabStatisticDesktop";

export const CreateCampaignTabStatistic: React.FC = observer(() => {
  const {
    campaignStatisticStore: { totalStatistic, attach, detach },
  } = useStores();
  const isMobile = useIsMobile();

  useEffect(() => {
    attach();
    return detach;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (totalStatistic === undefined) {
    if (isMobile) {
      return <StatisticTouchSkeletonPage />;
    }
    return <StatisticDesktopSkeletonPage />;
  }

  if (isMobile) {
    return <CreateCampaignTabStatisticTouch />;
  }
  return <CreateCampaignTabStatisticDesktop />;
});
